import { useLocale } from '../../../hooks/useLocale';
import { ShortUser } from '../../Murabaha/models/transfer_unit';

interface IApiClient {
  id: number;
  name: string;
  masked_client_id: string;
  created_by: number;
  is_active: boolean;
  created_at: Date;
  user: ShortUser;

  // Locals
  ip_whitelist: string[];
  x509_certificate?: File;
}

class ApiClientModel implements IApiClient {
  id: number;
  name: string;
  masked_client_id: string;
  created_by: number;
  is_active: boolean;
  created_at: Date;
  user: ShortUser;

  // Locals
  ip_whitelist: string[];
  x509_certificate?: File;

  constructor(data: Partial<IApiClient>) {
    this.id = data.id || 0;
    this.name = data.name || '';
    this.masked_client_id = data.masked_client_id || '';
    this.created_by = data.created_by || 0;
    this.is_active = data.is_active || false;
    this.created_at = data.created_at || new Date();
    this.user = data.user || { id: 0, english_name: '', arabic_name: '' };

    // Locals
    this.ip_whitelist = data.ip_whitelist || [];
    this.x509_certificate = data.x509_certificate;
  }

  /** from json to class */
  static fromJson(json: any): ApiClientModel {
    return new ApiClientModel({
      ...json,
      created_at: json?.created_at ? new Date(json.created_at) : new Date(),
    });
  }

  copyWith(data: Partial<IApiClient>): ApiClientModel {
    return new ApiClientModel({
      id: data.id ?? this.id,
      name: data.name ?? this.name,
      masked_client_id: data.masked_client_id ?? this.masked_client_id,
      created_by: data.created_by ?? this.created_by,
      is_active: data.is_active !== undefined ? data.is_active : this.is_active,
      created_at: data.created_at ?? this.created_at,
      user: data.user ?? this.user,

      // Locals
      ip_whitelist: data.ip_whitelist ?? this.ip_whitelist,
      x509_certificate: data.x509_certificate ?? this.x509_certificate,
    });
  }

  get isDtoValid() {
    return (
      this.name.trim() !== '' &&
      this.ip_whitelist.length > 0 &&
      this.x509_certificate !== undefined &&
      this.created_by > 0
    );
  }

  get fullName() {
    const { isArabic } = useLocale();
    return isArabic ? this.user.arabic_name : this.user.english_name;
  }
}

export default ApiClientModel;

interface IApiClientResponse {
  id: number;
  client_id: string;
  client_secret: string;
}

class ApiClientResponseModel implements IApiClientResponse {
  id: number;
  client_id: string;
  client_secret: string;

  constructor(data: Partial<IApiClientResponse>) {
    this.id = data?.id || 0;
    this.client_id = data?.client_id || '';
    this.client_secret = data?.client_secret || '';
  }

  static fromJson(json: any): ApiClientResponseModel {
    return new ApiClientResponseModel(json);
  }

  get isDataInvalid() {
    return this.client_id.trim() === '' || this.client_secret.trim() === '';
  }
}

export { ApiClientResponseModel };
